import cx from 'classnames';
import React from 'react';

import * as styles from './List.module.css';

const List = ({
	list,
	compact = false,
	className = '',
}: {
	list: string[];
	compact?: boolean;
	className?: string;
}) => {
	return (
		<ul
			className={cx(styles.list, className, {
				[styles.compact]: compact,
			})}
		>
			{list &&
				list.map((item, key) => (
					<li className={styles.item} key={key}>
						{item}
					</li>
				))}
		</ul>
	);
};

export default List;
